<template>
  <v-card>
    <v-card-title>
      <h4>{{ summary == null || summary[0] == null ? 'No Contests' : summary[0].name }}</h4>
    </v-card-title>
    <v-divider></v-divider>
    <v-list v-if="summary != null && summary[0] != null" dense two-line>
      <v-list-item v-for="(item, index) in summary[0].contestItems" :key="index">
        <v-list-item-content>
          <v-list-item-title v-html="item.name"></v-list-item-title>
          <v-list-item-subtitle>({{ formatDate(item.startDate) }} - {{ formatDate(item.endDate) }})</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-action-text>{{ item.entries }}</v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    summary: [] | null
  }),
  created () {
    this.loadContestSummary()
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadContestSummary()
      }
    }
  },
  methods: {
    async loadContestSummary () {
      if (this.user == null || this.user.userId == null || this.user.userId === '') {
        // console.log('User ID not set, unable to load contest summary')
        this.summary = null
        return
      }
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_REWARDS}/user-contests?userId=${this.user.userId}`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (getResponse === undefined || getResponse.data === '') {
        this.summary = null
      } else {
        this.summary = getResponse.data
      }
    },
    formatDate (aDate) {
      return moment(String(aDate)).format('MM/DD/YYYY')
    }
  }
}
</script>
<style>
</style>
